import { render, staticRenderFns } from "./ResearcherProfile.vue?vue&type=template&id=c328ce5e&"
import script from "./ResearcherProfile.vue?vue&type=script&lang=js&"
export * from "./ResearcherProfile.vue?vue&type=script&lang=js&"
import style0 from "./ResearcherProfile.vue?vue&type=style&index=0&id=c328ce5e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports